import { connect } from 'react-redux';
import { convertToOneColorPopupSelector } from '../../../../../../../../redux/logo-editing/logo-editing.selectors';
import { convertToOneColorDispatcher } from '../../../../../../../../redux/logo-editing/logo-editing.dispatchers';
import { ConvertToOneColorComponent } from './convert-to-one-color';
export const ConvertToOneColor = connect(convertToOneColorPopupSelector, convertToOneColorDispatcher)(ConvertToOneColorComponent);